import { FC, useEffect, useState } from "react";

import { DesignToken, SpacingToken, Tooltip } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import Text from "components/layout/Text";
import { withVar } from "themes/helpers";

import KeyWrapper from "./KeyWrapper";

interface IProps {
  trigger: React.ReactNode;
  title: string;
  firstKey: string;
  secondKey?: string;
  thirdKey?: string;
  hideTooltip?: boolean;
  offsetX?: number;
}

const ShortcutTooltip: FC<IProps> = ({ trigger, title, firstKey, secondKey, thirdKey, hideTooltip, offsetX }) => {
  const [shouldShowTooltip, setShouldShowTooltip] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    if (isHovered) {
      timeout = setTimeout(() => {
        setShouldShowTooltip(true);
      }, 400);
    } else {
      setShouldShowTooltip(false);
    }
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    return () => clearTimeout(timeout);
  }, [isHovered]);

  useEffect(() => {
    if (hideTooltip) {
      setIsHovered(false);
      setShouldShowTooltip(false);
    }
  }, [hideTooltip]);

  return (
    <Tooltip
      triggerRenderer={() => (
        <Flex
          onMouseEnter={() => !hideTooltip && setIsHovered(true)}
          onMouseLeave={() => !hideTooltip && setIsHovered(false)}
        >
          {trigger}
        </Flex>
      )}
      theme="invert"
      isVisible={shouldShowTooltip && !hideTooltip}
      hoverOutDelayTimeout={0}
      arrowOffsetX={offsetX}
    >
      <Flex column gap={withVar(SpacingToken.Spacing1)}>
        <Text fontSize="15px" lineHeight="22px" whiteSpace="nowrap" textAlign="center">
          {title}
        </Text>
        <Flex justifyContent="center">
          <KeyWrapper keyName={firstKey} />
          {secondKey && (
            <>
              <Text
                fontSize="15px"
                lineHeight="22px"
                marginH={withVar(SpacingToken.Spacing05)}
                color={withVar(DesignToken.ContentInvertSecondary)}
              >
                +
              </Text>
              <KeyWrapper keyName={secondKey} />
            </>
          )}
          {thirdKey && (
            <>
              <Text
                fontSize="15px"
                lineHeight="22px"
                marginH={withVar(SpacingToken.Spacing05)}
                color={withVar(DesignToken.ContentInvertSecondary)}
              >
                +
              </Text>
              <KeyWrapper keyName={thirdKey} />
            </>
          )}
        </Flex>
      </Flex>
    </Tooltip>
  );
};

export default ShortcutTooltip;
